import angular from "angular";

angular
    .module('organizationsControl.organizationForm')
    .component('organizationFilesForm', {
        controller: ['Upload', 'notifier', '$http', controller],
        template: require('./organization-files-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(Upload, notifier, $http) {

    let $ctrl = this;

    $ctrl.file = null;

    $ctrl.$onInit = function () {
        $ctrl.organization = $ctrl.resolve.organization;

        $ctrl.getFiles();
    };

    $ctrl.getFiles = () => {
        $http
            .get(`/control-panel/organizations/${$ctrl.organization.id}/get-files`)
            .then(res => {
                $ctrl.files = res.data;
            });
    };

    $ctrl.upload = () => {
        Upload
            .upload({
                url: `/control-panel/organizations/${$ctrl.organization.id}/add-file`,
                data: {file: $ctrl.file}
            })
            .then(
                res => {
                    $ctrl.loading = false;

                    notifier.successNotify('Успешно добавлен');

                    $ctrl.files.push({
                        id: res.data.id,
                        name: $ctrl.file.name
                    });

                    $ctrl.file = null;
                },
                err => {
                    $ctrl.loading = false;
                    notifier.errorResponseNotify(err);
                }
            );
    };

    $ctrl.delFile = (file, ind) => {
        $http
            .post(`/control-panel/organizations/${$ctrl.organization.id}/del-file`, {file_id: file.id})
            .then(res => {
                $ctrl.files.splice(ind, 1);

                notifier.successNotify('Успешно удален');
            });
    };
}



// WEBPACK FOOTER //
// ./resources/assets/modules/organizations-control/organization-files-form/organization-files-form.js